import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { BaseMediaClientError } from '../../models/errors';
export var MediaStoreError = /*#__PURE__*/function (_BaseMediaClientError) {
  _inherits(MediaStoreError, _BaseMediaClientError);
  var _super = _createSuper(MediaStoreError);
  function MediaStoreError(reason, innerError) {
    var _this;
    _classCallCheck(this, MediaStoreError);
    _this = _super.call(this, reason);
    _this.reason = reason;
    _this.innerError = innerError;
    return _this;
  }
  _createClass(MediaStoreError, [{
    key: "attributes",
    get: function get() {
      var reason = this.reason,
        innerError = this.innerError;
      return {
        reason: reason,
        innerError: innerError
      };
    }
  }]);
  return MediaStoreError;
}(BaseMediaClientError);
export function isMediaStoreError(err) {
  return err instanceof MediaStoreError;
}